<template>
  <div id="tryout-review">
    <div class="form-horizontal form-bordered">
      <div class="form-group">
        <label class="col-md-2 control-label">Kode Tryout</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.code }}</strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Jenis Tryout</label>
        <div class="col-md-8 col-xs-12">
          <strong v-if="$store.state.tryout.is_repeated">INSTANT</strong>
          <strong v-else>BERJANGKA</strong>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Nama Tryout</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.name }}</strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Jenjang / Jenis</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.level }} / {{ $store.state.tryout.type }}</strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Durasi</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.duration }} menit</strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Opsi</label>
        <div class="col-md-8 col-xs-12">
          <strong v-if="$store.state.tryout.is_free_access">Akses Gratis</strong><br>
          <strong v-if="$store.state.tryout.is_repeated">Tryout Berulang</strong>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Mulai</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.start_date }} {{ $store.state.tryout.start_time }}</strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Berakhir</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.end_date }} {{ $store.state.tryout.end_time }}</strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Subtests</label>
        <div class="col-md-8 col-xs-12">
          <table class="table table-hover">
            <thead>
              <tr>
                <td>#</td>
                <td>Gambar</td>
                <td>Mata Pelajaran</td>
                <td>Jumlah Soal</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(subtest, index) in $store.state.tryout.subtests" v-bind:key="index">
                <td>{{ index + 1 }}</td>
                <td><img :src="subtest.subject_picture" class="subject-picture"></td>
                <td>{{ subtest.subject_name }}</td>
                <td>{{ subtest.details.length}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <hr>
    <div class="text-center">
      <button v-if="isDraft" type="button" class="btn btn-danger" @click="confirmReview()">Ubah Status Ke REVIEW</button>
      <button v-if="isReviewed" type="button" class="btn btn-success" @click="confirmDraft()">Kembali ke DRAFT</button>
      <button v-if="isReviewed" type="button" class="btn btn-danger" @click="confirmPublish()">Ubah Status ke PUBLISHED</button>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import TryoutService from '@/services/tryout.js'
import Spinner from '@/components/plugins/Spinner'
export default
{
  name: 'tryout-review',
  components: {
    'app-spinner': Spinner
  },
  data: function() {
    return {
      isLoading: false
    }
  },
  computed: {
    isDraft: function() {
      return this.$store.state.tryout.status == 'DRAFT'
    },
    isReviewed: function() {
      return this.$store.state.tryout.status == 'REVIEW'
    }
  },
  methods: {
    confirmReview: function() {
      var confirmed = confirm("Apakah anda yakin untuk mengubah status Tryout ini menjadi 'REVIEW' ?")
      if (confirmed) {
        this.isLoading = true
        var context = this
        var id = this.$store.state.tryout.id
        TryoutService.reviewTryout(id, function(result) {
          context.isLoading = false
          if (result.success) {
            context.$store.commit('tryout_init', result.data)
          }
        })
      }
    },
    confirmPublish: function() {
      var confirmed = confirm("Apakah anda yakin untuk mengubah status Tryout ini menjadi 'PUBLISH' ?")
      if (confirmed) {
        this.isLoading = true
        var context = this
        var id = this.$store.state.tryout.id
        TryoutService.publishTryout(id, function(result) {
          context.isLoading = false
          if (result.success) {
            context.$store.commit('tryout_init', result.data)
          }
        })
      }
    },
    confirmDraft: function() {
      var confirmed = confirm("Apakah anda yakin untuk mengubah status Tryout ini menjadi 'DRAFT' ?")
      if (confirmed) {
        this.isLoading = true
        var context = this
        var id = this.$store.state.tryout.id
        TryoutService.draftTryout(id, function(result) {
          context.isLoading = false
          if (result.success) {
            context.$store.commit('tryout_init', result.data)
          }
        })
      }
    }

  }
}
</script>




// WEBPACK FOOTER //
// Review.vue?d8ee4384